export async function sha256Hex(data) {
    const buffer = data instanceof Blob
        ? await data.arrayBuffer()
        : data instanceof Uint8Array
            ? data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength)
            : data;
    const digest = await crypto.subtle.digest('SHA-256', buffer);
    return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
export function deduplicationKey(tenantId, sha256) {
    if (!/^[a-f0-9]{64}$/i.test(sha256))
        throw new Error('INVALID_SHA256');
    return `${encodeURIComponent(tenantId)}/${sha256.toLowerCase()}`;
}
